import { AuthChangeEvent } from '@supabase/supabase-js';

import { Dispatch, SetStateAction, createContext } from 'react';

export const SupabaseAuthStateChangeContext = createContext<
  [
    AuthChangeEvent | undefined,
    Dispatch<SetStateAction<AuthChangeEvent | undefined>>
  ]
>([undefined, () => void 0]);
